// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {ImageSrc} from 'docs/markdoc/attribute-types';

export const PartnerPerk: MarkdocTagRegistration = {
  tag: 'partner-perk',
  component: 'PartnerPerk',
  description: 'partner perks tag',
  attributes: {
    title: {
      type: String,
      required: true,
      localizable: true,
      description: 'partner perk title',
    },
    subtitle: {
      type: String,
      required: true,
      localizable: true,
      description: 'partner perk subtitle',
    },
    icon: {
      type: ImageSrc,
      required: true,
      description: 'partner icon',
    },
  },
  children: ['paragraph'],
};
